import { Header } from "@/presentation/components";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";
import { BottomAppBar } from "@/presentation/components/layout/BottomAppBar";
import { useAuthContext } from "@/presentation/context";
import { routes } from "@/presentation/router";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './IncidentePage.css';
import CalendarioVisitas from "@/presentation/components/common/Calendar/Calendario";
import { useVisita } from "@/presentation/hooks";




export default function VisitasPage() {
    const navigate = useNavigate();
    const { user, logout } = useAuthContext();
    const {
        data,
        loadAll,
        loading,
        error,
    } = useVisita();

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const handleOpenDrawer = () => {
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleLogout = async () => {
        await logout();
        setIsDrawerOpen(false);
        navigate(routes.login, { replace: true });
    };
    useEffect(() => {
        loadAll();
    }, [loadAll]);



    const nuevoVisita = () => {
        navigate('/visita/formulario', { replace: true });
    };





    return (
        <div>
            <Header
                title="Visitas"
                onMenuClick={handleOpenDrawer}
            />

            <AppDrawer
                isOpen={isDrawerOpen}
                user={user}
                onClose={handleCloseDrawer}
                onLogout={handleLogout}
            />
            <main className="incidentes-page">
                {loading && (
                    <p className="incidentes-page__message">
                        Cargando Visitas...
                    </p>
                )}

                {error && (
                    <p className="incidentes-page__error">
                        {error}
                    </p>
                )}

                {!loading && !error && (
                    <CalendarioVisitas
                        visitas={data}
                        obtenerRutaDetalle={(visita) => `/visita/${visita.id}`}
                        obtenerEstadoDetalle={(visita) => ({
                            ubicacion_generica: visita.ubicacion_generica,
                            fecha: visita.fecha,
                        })}
                    />
                )}

            </main>




            <BottomAppBar
                items={[
                    {
                        label: 'Nueva Visita',
                        onClick: nuevoVisita,
                        icon: undefined,
                    },


                ]}
            />

        </div>
    );
}
